import axios from 'axios/index'

const namespaced = true

const state = {
  visible: false,
  portals: null,
  packages: null,
  statuses: null,
  definitePackage: null,
  documents: null,
  loading: false,
  pages: null,
  pids: null
}
const actions = {
  getReportExcelZip ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.get(`//${data.host}/reports/report_excel_zip/?host=${data.host}&package_id=${data.packageId}`, { responseType: 'blob' })
        .then((response) => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getReport4emptycont_new ({ commit }, data) {
    return new Promise((resolve, reject) => {
      /* axios({
        method: 'GET',
        url: '/account/report.xml'
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        }) */
      axios({
        method: 'GET',
        url: `//${data.host}/reports/report4emptycont_new/?host=${data.host}&package_id=${data.packageId}`
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getReport4 ({ commit }, data) {
    return new Promise((resolve, reject) => {
      /* axios({
        method: 'GET',
        url: '/account/report.xml'
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        }) */
      axios({
        method: 'GET',
        url: `//${data.host}/reports/report4_new/?host=${data.host}&package_id=${data.packageId}`
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getStatuses ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v3.0/portals/${data.portalId}/statuses/`
      })
        .then(response => {
          commit('setStatuses', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPortalsList ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/api/private/v3.0/portals/'
      })
        .then(response => {
          commit('setPortalsList', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPackagesFromPortal ({ commit }, data) {
    commit('setVisible', true)
    const params = new URLSearchParams(data.queryParams).toString()
    const url = `/api/private/v3.0/portals/${data.portalId}/packages/?`
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: url + params
      })
        .then(response => {
          commit('setPackages', response.data)
          commit('setVisible', false)
          resolve()
        })
        .catch(error => {
          commit('setVisible', false)
          reject(error)
        })
    })
  },
  getDefinitePackageFromPortal ({ commit }, data) {
    commit('setVisible', true)
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v3.0/portals/${data.portalId}/packages/2039795/`
      })
        .then(response => {
          commit('setDefinitePackage', response.data[0])
          commit('setVisible', false)
          resolve()
        })
        .catch(error => {
          commit('setVisible', false)
          reject(error)
        })
    })
  },
  loadPackageDocuments ({ commit }, data) {
    commit('setLoading', true)
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v3.0/portals/${data.portalId}/packages/${data.package}/documents/`
      })
        .then(response => {
          commit('setPackageDocuments', response.data)
          commit('setLoading', false)
          resolve()
        })
        .catch(error => {
          commit('setVisible', false)
          reject(error)
        })
    })
  }
}
const mutations = {
  setLoading (state, value) {
    state.loading = value
  },
  setVisible (state, value) {
    state.visible = value
  },
  setPortalsList (state, data) {
    state.portals = data
  },
  setPackages (state, data) {
    for (let i = 0; i < data.packages.length; i++) {
      data.packages[i].documents = null
      data.packages[i].actions = { visible: false }
      data.packages[i].index = i.toString()
      data.packages[i].waybill = data.packages[i].info[101]
      data.packages[i].vehicle = data.packages[i].info[104]
      data.packages[i].manifest = { id: null, progress: false }
      const convertedStatus = state.statuses.filter((s) => {
        return s.id === data.packages[i].status
      })
      data.packages[i].converted_status = convertedStatus[0].name
    }

    state.packages = data.packages.filter((p) => {
      return p.status !== 107
    })
    if (data.pages) {
      state.pages = data.pages
    }
    if (data.pids) {
      state.pids = data.pids
    }
  },
  setDefinitePackage (state, data) {
    data.documents = null
    data.actions = { visible: false }
    data.index = '0'
    state.packages = [data]
  },
  setPackageDocuments (state, data) {
    state.documents = data
  },
  setStatuses (state, data) {
    state.statuses = data
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations
}
